import Logo from "../../../src/assets/img/Mpink.png";

const Loader = () => {
  return (
    <div className="loader_div">
      <img src={Logo} alt="loader" />
    </div>
  );
};

export default Loader;
